module.exports = __webpack_public_path__ + "img/background-study-facility-location.11710cab.jpg";